import React from 'react';

const ErrorScreen = ({ error }) => {
  const handleRetry = () => {
    // Reload the page to retry
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-toon-yellow flex flex-col items-center justify-center p-4">
      {/* Logo */}
      <img 
        src="/assets/Toon_House_Logo.svg" 
        alt="Toon House Logo" 
        className="h-24 mb-8"
      />
      
      {/* Error Message */}
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="text-red-500 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <h2 className="text-2xl font-bold mb-2">Oops! Something went wrong</h2>
        
        {error && (
          <div className="mb-4">
            <p className="text-gray-700 mb-2">{error.message || 'Unable to load poll configuration'}</p>
            {error.details && (
              <p className="text-sm text-gray-500">{error.details}</p>
            )}
            {error.code && (
              <p className="text-xs text-gray-400 mt-2">Error code: {error.code}</p>
            )}
          </div>
        )}
        
        <p className="text-gray-600 mb-6">We're having trouble loading the voting page. Please try again.</p>
        
        <button 
          onClick={handleRetry}
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-6 rounded-full transition duration-200"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorScreen;